import { cacheFirstConfig, http } from '@/core/helpers/axiosHelper';

export class ActivityRiskService {
   async getActivityRisks() {
      return await http.get(`/activity-risks`, cacheFirstConfig).then((response: any) => {
         return response.data;
      });
   }
}
